import Vue from 'vue'
import VueRouter from 'vue-router'

//解决vue路由重复导航错误
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// import Home from '../views/Home.vue'
const Home = () => import('@/views/Home')
const Page = () => import('@/views/Page')
// const 404 = () => import('@/page/index')
// const Login = () => import('@/page/index')
// const Register = () => import('@/views/Register')
// const UserInfo = () => import('@/views/userinfo/userInfo')

const Dynamic = () => import('@/views/dynamic')
const ScientificResearch = () => import('@/views/scientificResearch')
const Help = () => import('@/views/help')
const ResourceBase = () => import('@/views/resourceBase/resourceIndex')
const Germplasm = () => import('@/views/resourceBase/germplasmAnimalIndex/germplasmIndex')
const Seed = () => import('@/views/resourceBase/germplasmAnimalIndex/seed')
const DriedLeaf = () => import('@/views/resourceBase/germplasmAnimalIndex/driedLeaf')
const Dna = () => import('@/views/resourceBase/germplasmAnimalIndex/dna')
const GermplasmAnimal = () => import('@/views/resourceBase/germplasmAnimalIndex/germplasmAnimal')
const DnaBar = () => import('@/views/resourceBase/dnaBarIndex/dnaBarIndex')
const SpineAnimal = () => import('@/views/resourceBase/dnaBarIndex/spineAnimal')
const VascularPlant = () => import('@/views/resourceBase/dnaBarIndex/vascularPlant')

const List = () => import('@/views/resourceBase/listIndex/listIndex')
const ProtectList = () => import('@/views/resourceBase/listIndex/protectList')
const UniqueList = () => import('@/views/resourceBase/listIndex/uniqueList')
const WildPlants = () => import('@/views/resourceBase/listIndex/wildPlants')
const TerrestrialWildlife = () => import('@/views/resourceBase/listIndex/terrestrialWildlife')
const ProtectedWildPlants = () => import('@/views/resourceBase/listIndex/protectedWildPlants')

const WorkGuide = () => import('@/views/resourceBase/workGuideIndex/workGuideIndex')
const Management = () => import('@/views/resourceBase/workGuideIndex/management')
const Filling = () => import('@/views/resourceBase/workGuideIndex/filling')

const Picture = () => import('@/views/scientificResearch/picture')
const Video = () => import('@/views/scientificResearch/video')
const Information = () => import('@/views/dynamic/information')
const ProgressWork = () => import('@/views/dynamic/progressWork')
const Problem = () => import('@/views/help/problem')
const RelationWe = () => import('@/views/help/relationWe')
const Detail = () => import('@/views/detail/detail')
const TableDetail = () => import('@/views/tableDetail/tableDetail')
const SearchPage = () => import('@/views/searchPage/searchPage')
const SearchDetail = () => import('@/views/searchDetail/searchDetail')

const HelpDocuments = () => import('@/views/dynamic/helpDocuments')
const StandardSpecification = () => import('@/views/dynamic/standardSpecification')




Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '首页',
    meta: {
      title:'首页'
    },
    component: Page
  },
  // {
  //   path: '/:pathMatch(.*)*',
  //   redirect: '/404',
  //   name: 'Any',
  //   meta: {
  //     title: '任意路由',
  //     hidden: true,
  //     icon: 'DataLine'
  //   },
  // },
  // {
  //   path: '/register',
  //   name: '注册',
  //   component: Register,
  //   meta: {
  //     title:'注册'
  //   }
  // }, {
  //   path: '/userInfo',
  //   name: '个人信息',
  //   component: UserInfo,
  //   meta: {
  //     title:'个人信息'
  //   }
  // },
  {
    path: '/searchPage',
    name: '搜索',
    meta: {
      title: '搜索',
      keepAlive: true,
      isUseCache: false,
    },
    component: SearchPage
  },
  {
    path: '/resourceBase',
    redirect: '/',
    name: '资源',
    // redirect: '/resourceBase',
    meta: {
      title:'资源'
    },
    component: ResourceBase,
    children: [
      {
        path:"germplasm",
        redirect: '/',
        name:"种质资源",
        component:Germplasm,
        meta: {
          isAuth: true,
          title:'种质资源'
        },
        children: [
          {
            path:"dna",
            name:"DNA",
            meta: {
              isAuth: true,
              title:'DNA'
            },
            component:Dna,
          },
          {
            path:"seed",
            name:"植物种质",
            meta: {
              isAuth: true,
              title:'植物种质'
            },
            component:Seed,
          },
          {
              path:"driedLeaf",
              name:"干燥叶片",
              meta: {
                isAuth: true,
                title:'干燥叶片'
              },
              component:DriedLeaf},
          {
            path:"germplasmAnimal",
            name:"动物种质",
            meta: {
              isAuth: true,
              title:'动物种质'
            },
            component:GermplasmAnimal},
        ]
      },
      {
        path:"dnaBar",
        redirect: '/',
        name:"DNA条形码",
        meta: {
          title:'DNA条形码',
          isAuth: true,
        },
        component:DnaBar,
        children: [
          {
            path:"spineAnimal",
            name:"脊椎动物",
            meta: {
              isAuth: true,
              title:'脊椎动物'
            },
            component:SpineAnimal,
          },
          {
            path:"vascularPlant",
            name:"维管植物",
            meta: {
              isAuth: true,
              title:'维管植物'
            },
            component:VascularPlant,
          }
        ]
      },
      {
        path:"list",
        redirect: '/',
        name:"名录",
        meta: {
          isAuth: true,
          title:'名录'
        },
        component:List,
        children: [
          {
            path:"protectList",
            name:"高黎贡山-伯舒拉岭受威胁植物名录",
            meta: {
              isAuth: true,
              title:'高黎贡山-伯舒拉岭受威胁植物名录'
            },
            component:ProtectList,
          },
          {
            path:"uniqueList",
            name:"高黎贡山特有植物名录",
            meta: {
              isAuth: true,
              title:'高黎贡山特有植物名录'
            },
            component:UniqueList,
          }, {
            path:"wildPlants",
            name:"怒江州高黎贡山野生植物名录",
            meta: {
              isAuth: true,
              title:'怒江州高黎贡山野生植物名录'
            },
            component:WildPlants,
          }, {
            path:"terrestrialWildlife",
            name:"怒江州高黎贡山陆生野生动物（脊椎动物）",
            meta: {
              isAuth: true,
              title:'怒江州高黎贡山陆生野生动物（脊椎动物）'
            },
            component:TerrestrialWildlife,
          },, {
            path:"protectedWildPlants",
            name:"高黎贡山-伯舒拉岭重点保护野生植物名录",
            meta: {
              isAuth: true,
              title:'高黎贡山-伯舒拉岭重点保护野生植物名录'
            },
            component:ProtectedWildPlants,
          },


        ]
      },
      {
        path:"workGuide",
        redirect: '/',
        name:"工作指南",
        meta: {
          title:'工作指南'
        },
        component:WorkGuide,
        children: [
          {
            path:"management",
            name:"种质资源采集和管理规范",
            meta: {
              isAuth: true,
              title:'种质资源采集和管理规范'
            },
            component:Management,
          },
          {
            path:"filling",
            name:"野外数据填写规范 (植物)",
            meta: {
              isAuth: true,
              title:'野外数据填写规范 (植物)'
            },
            component:Filling,
          }
        ]
      }
    ],
  },{
    path: '/dynamic',
    redirect: '/',
    name: '动态',
    meta: {
      title:'动态'
    },
    component: Dynamic,
    children: [
      {
        path:"information",
        name:"动态资讯",
        meta: {
          title:'动态资讯'
        },
        component:Information},
      {
        path:"progressWork",
        name:"工作进展",
        meta: {
          title:'工作进展'
        },
        component:ProgressWork},
      {
        path:"standardSpecification",
        name:"标准规范",
        meta: {
          title:'标准规范'
        },
        component:StandardSpecification},
      {
        path:"helpDocuments",
        name:"帮助文档",
        meta: {
          title:'帮助文档'
        },
        component:HelpDocuments}
    ]
  },{
    path: '/scientificResearch',
    redirect: '/',
    name: '科考影像',
    meta: {
      isAuth: true,
      title:'科考影像'
    },
    component: ScientificResearch,
    children: [
      {
        path:"picture",
        name:"图片",
        meta: {
          isAuth: true,
          title:'图片'
        },
        component:Picture},
      {
        path:"video",
        name:"视频",
        meta: {
          isAuth: true,
          title:'视频'
        },
        component:Video}
    ]
  },{
    path: '/help',
    redirect: '/',
    name: '帮助',
    meta: {
      title:'帮助'
    },
    component: Help,
    children: [
      {
        path:"problem",
        name:"常见问题",
        meta: {
          title:'常见问题'
        },
        component:Problem},
      {
        path:"relationWe",
        name:"联系我们",
        meta: {
          title:'联系我们'
        },
        component:RelationWe}
    ]

  },
  {
    path:"/detail/:id/:formName",
    // path:"/detail/:formName",
    name:"详情",
    meta: {
      title: '详情',
      // isAuth: true,
    },
    component:Detail},
  {
    path:"/searchDetail",
    name:"详情",
    meta: {
      title: '详情',
      // isAuth: true,
    },
    component:SearchDetail},
  {
    path:"/tableDetail",
    name:"表格详情",
    meta: {
      title:  '表格详情',
    },
    component:TableDetail},

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach((to, from, next) => {
//   // next()
//   const needList = [
//     '/servicesForm','/auditInfo','/auditProgressInfo',
//     '/auditProgress','/pendAudit','/pendSubmit','/technologySafetyInfo',
//     '/projectLib','/resultsLib','/audited','/auditedInfo'
//   ]
//   const toPath = to.path
//   if (needList.includes(toPath)) {
//     let token = localStorage.getItem('access_token');
//     if (token === null || token === '') {
//       store.commit('openLogin',to)
//     } else {
//       next();
//     }
//   } else {
//     next()
//   }
//   window,scrollTo(0,0)
// });

export default router
